"use strict"

class SupportArticle {

    /**
     * @constructor
     * @param {Object} a
     */
    constructor(a) {
        this.Id = a.Id ? a.Id : null
        this.entryId = a.EntryId ? a.EntryId : null
        this.title = a.Title
        this.titleUrl = a.TitleUrl
        this.content = this.processContent(a.Content)
        this.contentText = this.getText()
        this.categories = a.Categories
        this.reseller = a.Reseller
        this.stackcp = a.Stackcp
        this.keywords = a.Keywords
        this.keywordsString = this.getKeywordsString()
        this.impressions = a.Counter
        this.voteDown = a.HelpedDown;
        this.voteUp = a.HelpedUp;
    }

    /**
     * @return {string}
     */
    getKeywordsString() {
        if(this.keywords && this.keywords.length) {
            return this.keywords.join(", ")
        } else {
            return ""
        }
    }

	/**
	 * @param {string} c
	 */
	processContent(c) {
        return c.replace(/%7Bfiledir_7%7D/g, "https://www.20i.com/assets/images")
	}

    /**
     * @return {string|null}
     */
	getText() {
        let c = new DOMParser().parseFromString(this.content, 'text/html')
        return c.body.textContent
	}

    /**
     * @return {(string|null)}
     */
    getExcerpt() {
        if(this.contentText) {
            if(this.contentText.split(" ").length > 50) {
                return this.contentText.split(" ").splice(0, 50).join(" ") + "..."
            } else {
                return this.contentText
            }
        }
        return null
    }

    /**
     * Get article url for support database at 20i.com
     *
     * @return {string}
     */
    getURL() {
        if(this.categories && this.categories.length) {
            return `/support-database#${this.titleUrl}`
        }

        return `/support-database`
    }
}
